export interface AddMasterPlanRequest {
    name: string;
    description?: string;
    distributionLaneId: string;
    timeZone: string;
    type: number; 
    organizationUnitId?: string;
    additionalData?: Record<string, string>;
}